/**
 * check if a given string is a url
 * @param query query to check for url
 * @returns boolean
 */
export const isUrl = (query: string): boolean => {
  if (!query) return false
  const regex = RegExp(
    // eslint-disable-next-line no-useless-escape
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/
  )
  return !!query.match(regex)
}
